import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs';
import { fadeAnimation } from 'src/animations';
import { ContactService } from '../../../services/contact.service';

@Component({
  selector: 'app-select-contact-information-type',
  templateUrl: './select-contact-information-type.component.html',
  styleUrls: ['./select-contact-information-type.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectContactInformationTypeComponent),
      multi: true
    }
  ],
  animations: [ fadeAnimation ]
})
export class SelectContactInformationTypeComponent implements ControlValueAccessor, OnDestroy, OnInit {

  @Input() appearance: 'standard' | 'fill' | 'outline' | 'raw' = 'fill';

  valueControl: FormControl = new FormControl();

  label: string = "Art";

  private _subscriptions: Subscription[] = [];

  constructor(
    public service: ContactService
  ) { }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
  }

  public onTouched: () => void = () => { };
  registerOnTouched = (fn: any) => this.onTouched = fn;

  registerOnChange(fn: any): void {
    this._subscriptions.push(this.valueControl.valueChanges.subscribe(fn));
  }

  setDisabledState = (isDisabled: boolean) => isDisabled ? this.valueControl.disable() : this.valueControl.enable();
  writeValue = (val: any) => this.valueControl.patchValue(val);

}
